import type { InvitationResponseDto } from '@/src/api/types/generated-types'

export type InvitedUser = {
  id: number
  email: string
  firstName: string | null
  lastName: string | null
  companyRole: string | null
  roles: string[]
  message: string | null
  expiresAt: string
  isEnergyTeam: boolean
  isInvited: true
  readonly: boolean
  locationsPermissions: {
    canSeeAllLocations: boolean
    allowedLocations: { id: string }[]
  }
}

export const mapInvitationToInvitedUser = (dto: InvitationResponseDto): InvitedUser => ({
  id: dto.id,
  email: dto.email,
  firstName: dto.firstName,
  lastName: dto.lastName,
  companyRole: dto.companyRole,
  roles: dto.roles,
  message: dto.message,
  expiresAt: dto.expiresAt,
  isEnergyTeam: dto.isEnergyTeam,
  isInvited: true as const,
  readonly: dto.readonly,
  locationsPermissions: {
    canSeeAllLocations: dto.canSeeAllLocations,
    allowedLocations: dto.allowedLocationFirebaseIds.map(id => ({ id })),
  },
})
